export enum WISHLISTS_SDK_EVENTS {
    WISHLIST_ITEM_CREATED = "wishlistItemCreated",
    WISHLIST_ITEM_DELETED = "wishlistItemDeleted",
}

export enum WISHLISTS_SDK_METHODS {
    OPEN_WISHLISTS_DRAWER = "openWishlistsDrawer",
    CLOSE_WISHLISTS_DRAWER = "closeWishlistsDrawer",
    CREATE_WISHLIST_ITEM = "createWishlistItem",
    DELETE_WISHLIST_ITEM = "deleteWishlistItem",
}
